
export function ResetZoomIcon({ height, width, color }: any) {
    return <svg id="i-zoom-reset" xmlns="http://www.w3.org/2000/svg" height={height || "1em"} width={width || "1em"} stroke={color || '#000000'} viewBox="0 0 32 32" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <circle cx="14" cy="14" r="12" />
        <path d="M23 23 L30 30" />
        <path d="M9 12 L9 9 12 9 M16 9 L19 9 19 12 M9 16 L9 19 12 19 M19 16 L19 19 16 19" />
    </svg>
}